import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  login: (username, password) =>
    client.post("/admin/login", { username, password }).then((r) => r.data),

  listProducts: (shop, subcategory) => {
    const params = {};
    if (shop) params.shop = shop;
    if (subcategory) params.subcategory = subcategory;
    return client.get("/products", { params }).then((r) => r.data);
  },

  listSubcategories: (shop) =>
    client.get("/products/subcategories", { params: shop ? { shop } : {} }).then((r) => r.data),

  createProduct: (token, product) =>
    client
      .post("/products", product, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),

  updateProduct: (token, id, product) =>
    client
      .put(`/products/${id}`, product, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),

  deleteProduct: (token, id) =>
    client
      .delete(`/products/${id}`, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),

  getSettings: () => client.get("/settings").then((r) => r.data),

  updateSettings: (token, settings) =>
    client
      .put("/settings", settings, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
};
